import { put, call, takeLatest } from 'redux-saga/effects'

import {
  login as loginApi,
  getDropboxOauthUrl as getDropboxOauthUrlApi,
  getOffice365AccessToken as getOffice365AccessTokenApi,
} from 'Service/Api'

import storage from 'Service/localStorage'
import { isAuthTokenValid } from 'Utils/validations'
import * as SessionTypes from 'Redux/Types/SessionTypes'
import * as SessionActions from 'Redux/Actions/SessionActions'
import { registerUserByOauth2 } from 'Redux/Actions/UserActions'
import { resetFileUploads } from 'Redux/Actions/UploadFileActions'

function* createSession({ payload }) {
  const { params } = payload
  const { email, password } = params
  try {
    const { data } = yield call(loginApi, email, password)
    yield put(SessionActions.createSessionSucceeded(data))
  } catch (error) {
    yield put(SessionActions.createSessionFailed(error))
  }
}

function* destroySession() {
  try {
    storage.removeItem('user')
    storage.removeItem('authToken')
    storage.removeItem('authTokenExpirationDate')
    storage.removeItem('selectedTransactionColumns')
    storage.removeItem('selectedArchiveTransactionColumns')
    storage.removeItem('selectedColumns')
    storage.removeItem('selectedExportColumns')
    yield put(resetFileUploads())
    yield put(SessionActions.clearAppState())
    yield put(SessionActions.destroySessionSucceeded())
  } catch (err) {
    yield put(SessionActions.destroySessionFailed(err))
  }
}

function* createSessionByOauth2({ payload }) {
  try {
    yield put(registerUserByOauth2(payload))
    yield put(SessionActions.createSessionByOauth2Succeeded())
  } catch (errors) {
    yield put(SessionActions.createSessionByOauth2Failed())
  }
}

function* getSession() {
  try {
    const authToken = storage.getItem('authToken')
    const authTokenExpirationDate = storage.getItem('authTokenExpirationDate')
    if (authToken && isAuthTokenValid(authTokenExpirationDate)) {
      yield put(SessionActions.getSessionSucceeded({ authToken, authTokenExpirationDate }))
    } else {
      throw new Error('Auth token is expired.')
    }
  } catch (err) {
    yield put(SessionActions.getSessionFailed(err))
  }
}

function* getDropboxOauthUrl() {
  try {
    const response = yield call(getDropboxOauthUrlApi)
    const { data } = response
    global.location.assign(data)
  } catch (err) {
    yield put(SessionActions.getDropboxOauthUrlFailed(err))
  }
}

function* getOffice365AccessToken({ payload }) {
  try {
    const response = yield call(getOffice365AccessTokenApi, payload)
    const { data: accessToken } = response
    yield put(registerUserByOauth2({ source: 'office365', accessToken }))
    yield put(SessionActions.createSessionByOauth2Succeeded())
  } catch (err) {
    yield put(SessionActions.createSessionByOauth2Failed())
  }
}

export default function* sessionSaga() {
  yield takeLatest(SessionTypes.GET_SESSION, getSession)
  yield takeLatest(SessionTypes.CREATE_SESSION, createSession)
  yield takeLatest(SessionTypes.DESTROY_SESSION, destroySession)
  yield takeLatest(SessionTypes.GET_DROPBOX_OAUTH_URL, getDropboxOauthUrl)
  yield takeLatest(SessionTypes.CREATE_SESSION_BY_OAUTH2, createSessionByOauth2)
  yield takeLatest(SessionTypes.GET_OFFICE365_ACCESS_TOKEN, getOffice365AccessToken)
}
